import React, { useId, useState } from 'react';
import styled from 'styled-components';
import { ClickableElement, Box, Grid, TextInline } from '@cko/primitives';
import { IconActionTriangleRight } from '@cko/icons';
import { usePopper } from 'react-popper';
import { ThreeDotMenuItem } from '../ThreeDotMenuItem';
const SubMenuContainer = styled(ClickableElement) `
  position: relative;
  width: 100%;
`;
const SubMenuLabel = styled(Box) `
  display: flex;
  align-items: center;
  justify-content: space-between;
  text-align: left;
  background-color: var(--control-bg-primary);
  padding: var(--layout-soybean) var(--layout-stamp);
  border-radius: var(--border-r-seed);
  font: var(--body-xs);

  :hover {
    background-color: var(--control-bg-decorative-hover);
  }
`;
/**
 * @deprecated - please use ui toolkit components
 */
export const FloatingBox = styled(Box) `
  position: absolute;
  min-width: 180px;
  z-index: 99;
  border-radius: var(--border-r-seed);
`;
const Menu = styled(Grid) `
  grid-gap: var(--layout-seed);
  padding: var(--layout-soybean);
  border-radius: var(--border-r-seed);
  box-shadow: var(--control-e-spoon);
  background-color: var(--control-bg-primary);
`;
/**
 * @deprecated - Please use the ActionMenu from UI Toolkit
 * {@link https://frontend-ds.cko-dev.ckotech.co/?path=/docs/actionmenu--docs}
 */
export const ThreeDotMenuSubMenu = ({ children, id, items, menuId = 'menu-sub-menu', showIcon = true, testId, text, textColor, ...rest }) => {
    const [isVisible, setIsVisible] = useState(false);
    const [referenceRef, setReferenceRef] = useState(null);
    const [popperRef, setPopperRef] = useState(null);
    const { styles, attributes } = usePopper(referenceRef, popperRef, {
        placement: 'right-start',
        modifiers: [
            {
                name: 'offset',
                options: {
                    offset: [0, 0],
                },
            },
            {
                name: 'flip',
                enabled: true,
            },
        ],
    });
    const randomId = useId();
    const referenceId = id || randomId;
    const subMenuId = menuId || `${referenceId}-submenu`;
    const show = () => {
        setIsVisible(true);
    };
    const hide = () => {
        setIsVisible(false);
    };
    const childOnClick = (e, onClick) => {
        onClick(e);
        setIsVisible(false);
    };
    if (!children && !items) {
        return null;
    }
    return (React.createElement(SubMenuContainer, { onMouseEnter: show, onMouseLeave: hide },
        React.createElement(SubMenuLabel, { "aria-controls": subMenuId, "aria-haspopup": "true", "data-testid": testId, id: referenceId, ref: setReferenceRef, ...rest },
            React.createElement(TextInline, { whiteSpace: "nowrap", color: textColor }, text),
            showIcon && React.createElement(IconActionTriangleRight, null)),
        isVisible && (React.createElement(FloatingBox, { "aria-labelledby": referenceId, id: subMenuId, ref: setPopperRef, role: "menu", style: styles.popper, ...attributes.popper },
            React.createElement(Menu, null,
                children,
                items?.map((item) => (React.createElement(ThreeDotMenuItem, { ...item, key: item.text, onClick: (e) => childOnClick(e, item.onClick) }))))))));
};
